import { grey } from '@material-ui/core/colors';

export default () => ({
  container: { margin: '0 0 1rem' },
  icon: { padding: 5 },
  label: { color: grey[600] },
});
